import styled from 'styled-components';
import Icon from '../../assets/images/WarningTriangleIcon.svg';

interface ErrorIconProps {
  /** Icon height in `px`. Defaults to `24px`. */
  height?: string;

  /** Icon width in `px`. Defaults to `24px`. */
  width?: string;

  /** Icon fill colour. Defaults to `#1D3042` */
  fill?: string;
}

const ErrorIcon = styled.span<ErrorIconProps>`
  ${({ height = '24px', width = '24px', fill = '#1D3042' }) => `
    background-color: ${fill};
    display: block;
    height: ${height};
    mask-image: url("${Icon}");
    mask-position: center center;
    mask-repeat: no-repeat;
    mask-size: 100%;
    position: relative;
    width: ${width};
  `}
`;

export default ErrorIcon;
